import React from "react";
import Select from "react-select";
import "../segment.css";
import { useEffect, useRef, useState } from "react";
import { IMetaData, IFilterDef, FilterDef, IExpression, IFilter, IRule, FilterUtils } from "../../../../services/SegmentService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCross, faPlus, faTachometerAlt, faThumbsDown, faXmark, faXmarkSquare } from "@fortawesome/free-solid-svg-icons";
import { boolean } from "yup";
import { CustomerRuleDetail } from "./CustomerRuleDetail";
import { EventRuleDetail } from "./EventRuleDetail";



export default class RuleComponent 
    extends React.Component<
        {addRule: any, removeRule: any, ruleChange: any, rule: IRule, filter: IFilter, meta: IMetaData[], isLast: boolean}, 
        {
            segmentMeta : IMetaData, filterDef: IFilterDef
        } > {
        
    constructor(props: any) {
        super(props);
        if(this.props.rule.data != null) {

            this.state = {
                segmentMeta : this.props.rule.data.segmentMeta!,
                filterDef: this.props.rule.data.filterDef!
            }
        } else {

            this.state = {
                segmentMeta : null!,
                filterDef: null!
            }
        }
    }

    ruleIdExist = () => this.props.rule.ruleId != null
        
    change = (event: any) => {
        
        const selectedKey = this.props.meta.find(m => m.source == event.source);
        const selectedFilterDef = selectedKey?.filterDef.find(f => f.key == event.value);

        this.props.rule.data = {
            segmentMeta: selectedKey!,
            filterDef: selectedFilterDef,
            where : []
        }

        this.setState({segmentMeta: selectedKey!, filterDef: selectedFilterDef!});
    }
    
    chooseFilterDef = (event: any) => {
        const selectedFilterDef = this.state.segmentMeta.filterDef.find(fd => fd.key == event.target.value)!;
        //console.log(selectedFilterDef);
        this.setState({filterDef: selectedFilterDef});
    }
 
    toSegmentOption = () => {
        let options = this.props.meta.map((m: IMetaData) => {
            const label = m.readableName;
            if(m.source == "customer") { 
                
                const subOptions = m.filterDef.map(f => {
                    return {source : m.source, type : m.type, label : f.readableName, value: f.key} 
                });
                
                return { label : label, options : subOptions};
            } else if(m.source == "event") {
                const subOptions = m.filterDef.map(f => {
                    return {source : m.source, type : m.type, label : f.readableName, value: f.key} 
                });
                
                return { label : label, options : subOptions};
            } 
            else {
                return { label : label, value : m.source};
            }
        });
        
        return options;
    }

    renderReadOnlyFilter = () => {

        let subFilter;

        if(this.props.rule.data.expressionKey != "value" && this.props.rule.data.filterDef.key != "customAttributes") {
           subFilter = this.props.rule.data.filterDef.expressions.filter(e => e.key == this.props.rule.data.expressionKey)[0]?.readableName;     
        } else {
           subFilter = "";     
        }

        return (
            <div className="segment-readonly">
                <div className="small font-weight-bold">
                {this.props.rule.data.segmentMeta.readableName == "User Attributes" ?
                        <>
                            <span>User</span>
                            <span>/</span>
                        </>
                        : <></>
                }
                    <span>{this.props.rule.data.filterDef.readableName}</span>
                 { subFilter != "" ? ""
                                  
                            // <span> / {subFilter}</span>
                    : ""
                    
                 } 
                 </div>
            </div>
        );
 
    }

    render() {
                                        
        return (
                <div className="row">
                    <div className="col-sm-10">
                        <div className="row">
                            <div className="col-sm-3">
                            {   this.ruleIdExist() == false ? 
                                <Select
                                onChange = {this.change} options={this.toSegmentOption()}
                                        placeholder = "Choose a filter"
                                /> : this.renderReadOnlyFilter()
                            
                            }
                            </div>
                            { 
                            this.state.filterDef ? 
                                (this.state.segmentMeta.source == "customer" 
                                    ? <CustomerRuleDetail rule={this.props.rule} filterDef={this.state.filterDef} segmentMeta={this.state.segmentMeta} changeRuleData={this.props.ruleChange} />
                                    : <EventRuleDetail rule={this.props.rule} filterDef={this.state.filterDef} segmentMeta={this.state.segmentMeta} changeRuleData={this.props.ruleChange} />
                                ) : ""
                            }
                        </div>
                    </div>
                    <div className="col-sm-2" style={{textAlign:"right"}}>
                        
                           
                        {this.props.isLast ? 
                            <button onClick={(e) => this.props.addRule(this.props.filter, this.state)} className="btn btn-yellow btn-sm" type="button">
                                <FontAwesomeIcon icon={faPlus} />
                                <span style={{width:"30px"}}>OR</span>
                            </button>  : "" }   
                            
                        { FilterUtils.nonEmptyRules(this.props.filter).length > 1 ? 

                            <button style={{marginLeft:"10px"}} onClick={e => this.props.removeRule(this.props.filter ,this.props.rule)} className="btn-delete btn" type="button">
                                <FontAwesomeIcon icon={faXmark} size="1x" />
                            </button>
                           : 
                           <button disabled style={{marginLeft:"10px", visibility: "hidden"}} onClick={e => this.props.removeRule(this.props.filter ,this.props.rule)} className="btn-delete btn" type="button">
                                <FontAwesomeIcon icon={faXmark} size="1x" />
                            </button>
                        }
                    </div>                    
                </div>
                );
    }
}